import { useState } from "react";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Chip, Stack } from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CheckIcon from "@mui/icons-material/Check";
import InfoIcon from "@mui/icons-material/Info";

import NoddokTableRow from "../../ui/NoddokTableRow";
import NoddokTableCell from "../../ui/NoddokTableCell";
import NoddokTableRowHeader from "../../ui/NoddokTableRowHeader";

import CustTextField from "../../ui/CustTextField";
import { useGlobalContext } from "../../../context/GlobalContext";
import BaseButton from "../../ui/BaseButton";

import moment from "moment";
import { NumericFormat } from "react-number-format";
import LightTooltip from "../../ui/LightTooltip";

function Row(props) {
    const { row, handleChange, amountExt, handleChangeAcc, expanded, t, todos, theme, goToTable } = props;

    return (
        <>
            <NoddokTableRow sx={{ backgroundColor: expanded === row.name ? theme.palette.CIT020 : "#f8f8f9" }}>
                <NoddokTableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => handleChangeAcc(row.name)}>
                        {expanded === row.name ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </NoddokTableCell>
                <NoddokTableCell>
                    <b>{row.name}</b>{" "}
                    <Typography component="span" fontSize={12}>
                        {row.subname ?? ""}
                    </Typography>
                </NoddokTableCell>
                <NoddokTableCell>
                    <Stack direction="row" alignItems="center" justifyContent="flex-end">
                        <NumericFormat
                            customInput={CustTextField}
                            issearch="true"
                            thousandSeparator={todos.amountFormat === "en-US" ? "," : "."}
                            decimalSeparator={todos.amountFormat === "en-US" ? "." : ","}
                            decimalScale={amountExt?.type === "trans" ? 0 : 2}
                            fixedDecimalScale={amountExt?.type === "trans" ? false : true}
                            allowNegative={amountExt?.type === "trans" ? false : true}
                            value={amountExt?.value ?? ""}
                            onValueChange={(values) => {
                                handleChange(values.floatValue, amountExt?.type);
                            }}
                            size="small"
                            error={
                                (amountExt?.type === "finalBalance" &&
                                    parseFloat(amountExt?.value) !== row.inputValidation) ||
                                (amountExt?.type === "initAmount" &&
                                    row.validation &&
                                    parseFloat(amountExt?.value) !== row.validation)
                            }
                            hiddenLabel
                            sx={{
                                "& input": {
                                    textAlign: "right",
                                },
                                "& .MuiInputBase-root": {
                                    color:
                                        (amountExt?.type === "finalBalance" &&
                                            parseFloat(amountExt?.value) === row.inputValidation) ||
                                        (amountExt?.type === "initAmount" &&
                                            row.validation &&
                                            parseFloat(amountExt?.value) === row.validation)
                                            ? "H100"
                                            : "initial",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor:
                                        (amountExt?.type === "finalBalance" &&
                                            parseFloat(amountExt?.value) === row.inputValidation) ||
                                        (amountExt?.type === "initAmount" &&
                                            row.validation &&
                                            parseFloat(amountExt?.value) === row.validation)
                                            ? "green !important"
                                            : "initial",
                                },
                            }}
                        />
                        {amountExt?.type === "initAmount" || amountExt?.type === "finalBalance" ? (
                            <LightTooltip
                                title={
                                    amountExt?.type === "initAmount" &&
                                    row.validation &&
                                    parseFloat(amountExt?.value) === row.validation
                                        ? t("converter.toolInitExt")
                                        : amountExt?.type === "initAmount" &&
                                          row.validation &&
                                          parseFloat(amountExt?.value) !== row.validation
                                        ? t("converter.toolInitExt2")
                                        : amountExt?.type === "finalBalance" &&
                                          parseFloat(amountExt?.value) === row.inputValidation
                                        ? t("converter.toolFinalExt")
                                        : amountExt?.type === "finalBalance" &&
                                          parseFloat(amountExt?.value) !== row.inputValidation
                                        ? t("converter.toolFinalExt2")
                                        : ""
                                }
                            >
                                <InfoIcon sx={{ fontSize: 16, width: 25 }} />
                            </LightTooltip>
                        ) : (
                            <Box sx={{ width: 30 }}></Box>
                        )}
                    </Stack>
                </NoddokTableCell>
                <NoddokTableCell>
                    <Stack direction="row" alignItems="center" justifyContent="flex-end">
                        {parseFloat(row.amountCalc).toLocaleString(todos.amountFormat, {
                            minimumFractionDigits: 2,
                        })}
                        {amountExt?.type === "initAmount" ? (
                            <LightTooltip title={t("converter.toolInitCalc")}>
                                <InfoIcon sx={{ fontSize: 16, width: 25 }} />
                            </LightTooltip>
                        ) : (
                            <Box sx={{ width: 25 }}></Box>
                        )}
                    </Stack>
                </NoddokTableCell>
                <NoddokTableCell align="right">
                    {amountExt?.value - row.amountCalc === 0 || (row.isInitAmount && row.amountCalc === 0)
                        ? "-"
                        : parseFloat((amountExt?.value ?? 0) - row.amountCalc).toLocaleString(todos.amountFormat, {
                              minimumFractionDigits: 2,
                          })}
                </NoddokTableCell>
                <NoddokTableCell>
                    {!row.warnings.find((item) => item.isActive) ? (
                        <CheckIcon sx={{ fill: theme.palette.H100 }} />
                    ) : (
                        <BaseButton variantType="errorTextButton" onClick={() => handleChangeAcc(row.name)}>
                            {t("converter.seeDetails")}
                        </BaseButton>
                    )}
                </NoddokTableCell>
            </NoddokTableRow>
            <TableRow
                sx={{
                    "& td": { border: 0 },
                    backgroundColor: theme.palette.CIT020,
                }}
            >
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={expanded === row.name} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                            <Table size="small" aria-label="warnings">
                                <TableBody>
                                    {!row.warnings.find((item) => item.isActive) ? (
                                        <TableRow>
                                            <TableCell sx={{ width: "81.3%" }}>
                                                <Typography fontSize={13}>{t("converter.noVal")}</Typography>
                                            </TableCell>
                                            <TableCell>
                                                <CheckIcon sx={{ fill: theme.palette.H100 }} />
                                            </TableCell>
                                        </TableRow>
                                    ) : (
                                        row.warnings.map((val, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{
                                                    "&:not(:last-child)": { borderBottom: "1px solid #E0E0E0" },
                                                }}
                                            >
                                                <TableCell sx={{ width: "82%" }}>
                                                    <Typography fontSize={13}>{val.text}</Typography>
                                                </TableCell>
                                                <TableCell>
                                                    {!val.isActive ? (
                                                        <CheckIcon sx={{ fill: theme.palette.H100 }} />
                                                    ) : (
                                                        <Chip
                                                            label={t("dashboard.revisiTable")}
                                                            sx={{
                                                                backgroundColor: row.isInitAmount
                                                                    ? theme.palette.O020
                                                                    : theme.palette.C020,
                                                            }}
                                                            onClick={
                                                                row.isInitAmount ? null : () => goToTable(val.type)
                                                            }
                                                        />
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
}

const AccordionTotals = (props) => {
    const {
        setAmountExt,
        amountExt,
        rowsDet,
        conversionData,
        goToTable,
        totalRevenue,
        totalEgress,
        hasDuplicateEntries,
    } = props;

    const { todos, theme, t } = useGlobalContext();

    const [expanded, setExpanded] = useState(false);

    const handleChange = (value, type) => {
        const newArr = amountExt.map((item) => {
            if (item.type === type) {
                item.value = value;
            }
            return item;
        });
        setAmountExt(newArr);
    };

    const handleChangeAcc = (newExpanded) => {
        setExpanded(newExpanded === expanded ? false : newExpanded);
    };

    const amountCalcFinalBal = parseFloat(
        ((conversionData.initial_balance ?? 0) + totalRevenue + totalEgress).toFixed(2)
    );

    const amountExtSumFinalBal =
        (parseFloat(amountExt[1]?.value) ?? 0) +
        (parseFloat(amountExt[2]?.value) ?? 0) +
        (parseFloat(amountExt[3]?.value) ?? 0);

    const rows = [
        {
            name: t("dashboard.transactions"),
            amountCalc: rowsDet.length,
            warnings: [
                {
                    text: `1. ${t("converter.transMess1")}`,
                    isActive: rowsDet.length !== parseInt(amountExt[0]?.value),
                },
                {
                    text: `2. ${t("converter.transMess2")}`,
                    isActive: rowsDet.find(
                        (item) =>
                            !item.date ||
                            !moment(item.date).isValid() ||
                            moment(item.date).isBefore(moment(conversionData.initial_date).subtract(5, "days")) ||
                            moment(item.date).isAfter(moment(conversionData.end_date).add(5, "days"))
                    ),
                    type: "date",
                },
                {
                    text: `3. ${t("converter.transMess3")}`,
                    isActive:
                        hasDuplicateEntries(rowsDet) &&
                        parseFloat(amountExt[4]?.value) !==
                            parseFloat(((conversionData.initial_balance ?? 0) + totalRevenue + totalEgress).toFixed(2)),
                    type: "duplicated",
                },
            ],
        },
        {
            name: t("converter.initAmount"),
            amountCalc: conversionData.calculated_initial_balance ?? 0,
            isInitAmount: true,
            validation: conversionData.previous_conversion_balance,
            warnings: [
                {
                    text: `1. ${t("converter.initMess")}`,
                    isActive:
                        conversionData.account_id?.system_integration !== 3 &&
                        parseFloat(amountExt[1]?.value) !== conversionData.calculated_initial_balance,
                },
            ],
        },
        {
            name: `(+) ${t("converter.revenue")}`,
            subname: `(${rowsDet.filter((item) => item.amount > 0).length} ${t("dashboard.transacc")})`,
            amountCalc: totalRevenue,
            warnings: [
                {
                    text: `1. ${t("converter.extAmountMess")}`,
                    isActive: parseFloat(amountExt[2]?.value) !== totalRevenue,
                    type: "revenue",
                },
            ],
        },
        {
            name: `(-) ${t("converter.egress")}`,
            subname: `(${rowsDet.filter((item) => item.amount < 0).length} ${t("dashboard.transacc")})`,
            amountCalc: totalEgress,
            warnings: [
                {
                    text: `1. ${t("converter.extAmountMess2")}`,
                    isActive: parseFloat(amountExt[3]?.value) !== totalEgress,
                    type: "egress",
                },
            ],
        },
        {
            name: t("converter.balance"),
            amountCalc: amountCalcFinalBal,
            inputValidation: parseFloat(amountExtSumFinalBal.toFixed(2)),
            warnings: [
                {
                    text: `1. ${t("converter.finalAmountMess")}`,
                    isActive: parseFloat(amountExt[4]?.value) !== parseFloat(amountExtSumFinalBal.toFixed(2)),
                },
                {
                    text: `2. ${t("converter.finalAmountMess2")}`,
                    isActive: parseFloat(amountExt[4]?.value) !== amountCalcFinalBal,
                },
            ],
        },
    ];

    return (
        <TableContainer>
            <Table
                aria-label="collapsible table"
                size="small"
                sx={{ borderCollapse: "separate", borderSpacing: "0 6px" }}
            >
                <TableHead>
                    <NoddokTableRowHeader>
                        <NoddokTableCell />
                        <NoddokTableCell />
                        <NoddokTableCell style={{ width: "20%" }}>
                            <Stack direction="row" alignItems="center" justifyContent="flex-end">
                                {t("converter.extAmount")}
                                <LightTooltip title={t("converter.toolAmountExt")}>
                                    <InfoIcon sx={{ fontSize: 16, ml: 1 }} />
                                </LightTooltip>
                            </Stack>
                        </NoddokTableCell>
                        <NoddokTableCell>
                            <Stack direction="row" alignItems="center" justifyContent="flex-end">
                                {t("converter.calcAmount")}
                                <LightTooltip title={t("converter.toolAmountCalc")}>
                                    <InfoIcon sx={{ fontSize: 16, ml: 1 }} />
                                </LightTooltip>
                            </Stack>
                        </NoddokTableCell>
                        <NoddokTableCell>
                            <Stack direction="row" alignItems="center" justifyContent="flex-end">
                                {t("converter.diff")}
                                <LightTooltip title={t("converter.toolDiff")}>
                                    <InfoIcon sx={{ fontSize: 16, ml: 1 }} />
                                </LightTooltip>
                            </Stack>
                        </NoddokTableCell>
                        <NoddokTableCell>
                            <Stack direction="row" alignItems="center">
                                {t("converter.pendingAct")}
                                <LightTooltip title={t("converter.toolPending")}>
                                    <InfoIcon sx={{ fontSize: 16, ml: 1 }} />
                                </LightTooltip>
                            </Stack>
                        </NoddokTableCell>
                    </NoddokTableRowHeader>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <Row
                            key={row.name}
                            row={row}
                            handleChange={handleChange}
                            amountExt={amountExt[index]}
                            handleChangeAcc={handleChangeAcc}
                            expanded={expanded}
                            t={t}
                            todos={todos}
                            theme={theme}
                            goToTable={goToTable}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AccordionTotals;
